/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tenant update data
 * @export
 * @interface UpdateTenantRequest
 */
export interface UpdateTenantRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    customerId?: string;
    /**
     * Tenant status
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    status?: UpdateTenantRequestStatusEnum;
    /**
     * Enrollment status. Note: 'suspended' can only be set via decommission API, not via manual update. To temporarily inactivate a tenant, set status='inactive' and keep enrollmentStatus='active'.
     * @type {string}
     * @memberof UpdateTenantRequest
     */
    enrollmentStatus?: UpdateTenantRequestEnrollmentStatusEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateTenantRequest
     */
    settings?: { [key: string]: any; };
}


/**
 * @export
 */
export const UpdateTenantRequestStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;
export type UpdateTenantRequestStatusEnum = typeof UpdateTenantRequestStatusEnum[keyof typeof UpdateTenantRequestStatusEnum];

/**
 * @export
 */
export const UpdateTenantRequestEnrollmentStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Rejected: 'rejected'
} as const;
export type UpdateTenantRequestEnrollmentStatusEnum = typeof UpdateTenantRequestEnrollmentStatusEnum[keyof typeof UpdateTenantRequestEnrollmentStatusEnum];


/**
 * Check if a given object implements the UpdateTenantRequest interface.
 */
export function instanceOfUpdateTenantRequest(value: object): value is UpdateTenantRequest {
    return true;
}

export function UpdateTenantRequestFromJSON(json: any): UpdateTenantRequest {
    return UpdateTenantRequestFromJSONTyped(json, false);
}

export function UpdateTenantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTenantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'status': json['status'] == null ? undefined : json['status'],
        'enrollmentStatus': json['enrollmentStatus'] == null ? undefined : json['enrollmentStatus'],
        'settings': json['settings'] == null ? undefined : json['settings'],
    };
}

export function UpdateTenantRequestToJSON(json: any): UpdateTenantRequest {
    return UpdateTenantRequestToJSONTyped(json, false);
}

export function UpdateTenantRequestToJSONTyped(value?: UpdateTenantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'slug': value['slug'],
        'customerId': value['customerId'],
        'status': value['status'],
        'enrollmentStatus': value['enrollmentStatus'],
        'settings': value['settings'],
    };
}

